<template>
  <div>
    <van-image
      width="100%"
      height="86"
      class="top-bg"
      :src="require('@/assets/topBg.png')"
    />
    <van-image
      width="201px"
      height="53px"
      class="logo-img"
      :src="require('@/assets/logo.png')"
      @click="backHome"
    />
    <div class="keyword-main" @mouseleave="clearList">
      <van-field
        v-model="keyword"
        @input="changeInput"
        @click="clickInput"
        class="keyword-input"
        placeholder="请输入您要搜索的资源名称"
      />
      <div class="keyword-content">
        <div class="keyword-list" v-if="keyword !== '' && list.length > 0">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="keyword-li"
            @click="clickKeyword($event.target.innerText)"
            v-html="item"
          ></div>
        </div>
      </div>
    </div>

    <van-button type="info" @click="onSearch" class="keyword-search"
      >搜索</van-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
      list: [],
    };
  },
  watch: {
    $route: function () {
      this.keyword = this.$route.query.keyword ? this.$route.query.keyword : "";
    },
  },
  methods: {
    // 点击搜索
    onSearch() {
      this.$router.push({
        path: "/",
        query: { keyword: this.keyword, t: Math.random(), page: 1 },
      });
    },
    backHome() {
      // this.$router.push({
      //   path: "https://kjpd.kepuchina.cn/",
      // });
      window.location = "https://kjpd.kepuchina.cn/";
    },
    clickKeyword(name) {
      this.keyword = name;
      this.onSearch();
      this.clearList();
    },
    clickInput() {
      if (this.keyword !== "") {
        this.changeInput(this.keyword);
      }
    },
    async changeInput(value) {
      try {
        const { data } = await this.$axios.post(`Articleeducate/getTitle`, {
          title: value,
        });
        this.list = data;
      } catch (error) {
        this.error = true;
        this.errorText = error?.errorMSg ?? "暂无数据";
      }
    },
    clearList() {
      this.list = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.top-bg {
  position: absolute;
  top: 0;
  left: 0;
}

.logo-img {
  margin-top: 17px;
  cursor: pointer;
}

.keyword-main {
  position: relative;
  top: -4px;
  display: inline-block;
  margin-left: 235px;

  .keyword-input {
    float: right;
    width: 615px;
    height: 45px;
    margin: 20px 20px 0 0;
    font-size: 20px;
    border: 1px solid #0047ff;
    border-radius: 4px;
  }

  .keyword-content {
    position: absolute;
    top: 65px;
    left: 0;
    z-index: 100;
  }

  .keyword-list {
    width: 575px;
    height: auto;
    padding: 20px;
    margin-top: 10px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 0 9px 0 rgb(0 0 0 / 14%);

    .keyword-li {
      width: 100%;
      overflow: hidden;
      font-size: 20px;
      font-weight: 400;
      line-height: 35px;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

      ::v-deep span {
        color: rgb(0 71 255 / 100%);
      }
    }
  }
}

.keyword-search {
  float: right;
  width: 127px;
  height: 45px;
  margin-top: 20px;
  background: #0047ff;
  border-radius: 4px;
}
</style>
